import * as THREE from 'three';

export class Lights {
  private ambientLight: THREE.AmbientLight;
  private directionalLight: THREE.DirectionalLight;
  private hemisphereLight: THREE.HemisphereLight;

  constructor() {
    // Ambient light for overall illumination
    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5);

    // Directional light (sun)
    this.directionalLight = new THREE.DirectionalLight(0xffffff, 1);
    this.directionalLight.position.set(5, 10, 5);
    this.directionalLight.castShadow = true;
    this.directionalLight.shadow.mapSize.width = 2048;
    this.directionalLight.shadow.mapSize.height = 2048;
    this.directionalLight.shadow.camera.near = 0.5;
    this.directionalLight.shadow.camera.far = 50;

    // Hemisphere light for natural outdoor lighting
    this.hemisphereLight = new THREE.HemisphereLight(0x87ceeb, 0x8b4513, 0.3);
    this.hemisphereLight.position.set(0, 10, 0);
  }

  public addToScene(scene: THREE.Scene): void {
    scene.add(this.ambientLight);
    scene.add(this.directionalLight);
    scene.add(this.hemisphereLight);
  }

  public dispose(): void {
    // Lights don't need explicit disposal, but included for consistency
  }
}
